import { Direction, EnemyType, ItemType } from "../../../defines/enums"
import { Symbol } from "../../../defines/symbols"
import { CombatConfig, Position, RenderConfig } from "../../../defines/types"
import { BounceEnemy } from "./bounce"

export class BounceSyncEnemy extends BounceEnemy {
  constructor(
    type: EnemyType,
    experience: number,
    combat: CombatConfig,
    position: Position,
    render: RenderConfig,
    name: string,
    direction?: Direction,
    optic?: ItemType
  ) {
    super(type, experience, combat, position, render, name, direction, optic)

    if (this._direction == Direction.UP || this._direction == Direction.DOWN) {
      this.render().symbol = [Symbol.VOID_VERT_1, Symbol.VOID_VERT_2]
    } else {
      this.render().symbol = [Symbol.VOID_HORZ_1, Symbol.VOID_HORZ_2]
    }
  }
}
